import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { homeHashFromLandingTo } from '@/landing/landing-home-hash'

export function LandingCtaLink({ to, children, className }: { to: string; children: ReactNode; className?: string }) {
  if (to.startsWith('http://') || to.startsWith('https://')) {
    return (
      <a href={to} className={className} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    )
  }
  const homeHash = homeHashFromLandingTo(to)
  if (homeHash) {
    return (
      <Link to={{ pathname: '/', hash: homeHash }} className={className}>
        {children}
      </Link>
    )
  }
  if (to.startsWith('#')) {
    return (
      <a href={to} className={className}>
        {children}
      </a>
    )
  }
  return (
    <Link to={to} className={className}>
      {children}
    </Link>
  )
}
